import { render, staticRenderFns } from "./RegisterSend.vue?vue&type=template&id=0ea1c570&scoped=true"
import script from "./RegisterSend.vue?vue&type=script&lang=js"
export * from "./RegisterSend.vue?vue&type=script&lang=js"
import style0 from "./RegisterSend.vue?vue&type=style&index=0&id=0ea1c570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1c570",
  null
  
)

export default component.exports